module.exports = __webpack_public_path__ + "img/icon_1_10.be62e6cb.png";